// Direktno, ne preko `@shared`: shared uvozi hooks, pa bi to bio krug
import { isIOS } from "../../shared/helpers/platform";

/**
 * - `granted`, `default`, `denied`: stanje dozvole u pregledaču. Odbijenu dozvolu iz koda
 *   više ne možemo da zatražimo ponovo; klijent je mora vratiti u podešavanjima.
 * - `needs-install`: iPhone u običnom Safari-ju. Tamo `Notification` ne postoji dok sajt
 *   nije dodat na početni ekran, pa dozvolu nema ni gde da se pita.
 * - `unsupported`: pregledač bez obaveštenja; nema šta da se ponudi.
 */
export type NotificationStatus =
  | "granted"
  | "default"
  | "denied"
  | "needs-install"
  | "unsupported";

export interface NotificationEnv {
  /** `undefined` kad pregledač nema Notification API. */
  permission?: NotificationPermission;
  isIOS: boolean;
  isStandalone: boolean;
}

export const getNotificationStatus = ({
  permission,
  isIOS,
  isStandalone,
}: NotificationEnv): NotificationStatus => {
  if (permission) return permission;
  return isIOS && !isStandalone ? "needs-install" : "unsupported";
};

export const readNotificationEnv = (): NotificationEnv => ({
  permission:
    typeof window !== "undefined" && "Notification" in window
      ? window.Notification.permission
      : undefined,
  isIOS: isIOS(),
  isStandalone:
    !!window.matchMedia?.("(display-mode: standalone)").matches ||
    (window.navigator as unknown as { standalone?: boolean }).standalone === true,
});
